import React from "react";
import { Card, CardContent } from "@material-ui/core";
import ChequeAdvancedSearchForm from "./ChequeAdvancedSearchForm";

class ChequeAdvancedSearch extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Card>
        <CardContent>
          <ChequeAdvancedSearchForm updateSearch={this.props.updateSearch} />
        </CardContent>
      </Card>
    );
  }
}

export default ChequeAdvancedSearch;
